import { useQuery } from '@tanstack/react-query'

import type { GetPolicyQueryOptions, PolicyDto } from '../../infra'
import { createGetPolicyQueryOptions } from '../../infra'

export function useGetPolicyQuery<TSelected = PolicyDto>(
  customerId: string | undefined,
  options?: GetPolicyQueryOptions<TSelected>
) {
  const queryOptions = createGetPolicyQueryOptions<TSelected>(
    customerId ?? '',
    options
  )

  return useQuery<PolicyDto, Error, TSelected>(queryOptions)
}
